import { render } from "./GobSection.vue?vue&type=template&id=66ddc7ee"
import script from "./GobSection.vue?vue&type=script&lang=js"
export * from "./GobSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__